<template>

  <div class="report-wrapper">
    <template v-if="!report.policy_service">

      <div class="report">
        <div class="report__data report__data--small">
          {{ formatDisplayDate(report.date) }}
        </div>
        <div class="report__data report__data--medium">{{ report.agent }}</div>
        <div class="report__data report__data--medium"> <template v-if="report.type">
            {{ report.type.name }}
          </template></div>
        <div class="report__data report__data--large">
          {{ report.description }}
        </div>
        <!-- <div class="report__data report__data--small">{{ storno }} CHF</div> -->
        <div class="report__data report__data--medium">
          {{ isOpened === 0 ? storno : balance }}
          CHF
        </div>

        <div v-if="report.payout_id != null && report.type_id == 9"
          class="report__data report__data--last icon icon__print" @click="openReport()">
        </div>
        <div v-if="!report.payout_id && report.type.is_manual" class="report__data report__data--last icon icon__delete"
          @click="deleteReport(report.uuid)">
        </div>
      </div>
    </template>
    <div class="report" v-else>
      <div class="report__data report__data--medium">
        {{ formatDisplayDate(report.date) }}
      </div>
      <div class="report__data report__data--large">
        {{ customerName }}
      </div>
      <div class="report__data report__data--large">
        {{ report.company }}
      </div>
      <div class="report__data report__data--medium">
        {{ insuranceType }}
      </div>
      <div class="report__data report__data--medium">
        {{ report.policy_number }}
      </div>
      <div class="report__data report__data--medium">
        {{ report.agent }}
      </div>
      <div class="report__data report__data--medium">
        <template v-if="report.type">
          {{ report.type.name }}
        </template>

      </div>
      <!-- <div class="report__data report__data--medium">{{ storno }} CHF</div> -->
      <div class="report__data report__data--medium">
        {{ isOpened === 0 ? storno : balance }}
        CHF
      </div>

      <router-link class="report__data report__data--last icon icon__right-arrow" :to="{
        name: 'AccountDetails',
        params: {
          entity: 'customer',
          id: report.customer.id,
        },
      }"></router-link>
    </div>
  </div>
</template>

<script>
import { formatDisplayDate } from "@/helpers/dateFormatters";
import statics from "@/statics";
import api from "@/api";

export default {
  name: "Report",

  props: {
    report: {
      required: true,
      type: Object,
    },
    teamId: {
      required: true,
      type: Number,
    },
  },

  data() {
    return {
      formatDisplayDate,
      statics,
    };
  },

  computed: {
    customerName() {
      if (this.report.customer) {
        if (this.report.customer.company_name) {
          return this.report.customer.company_name;
        }
        return `${this.report.customer.first_name} ${this.report.customer.last_name}`;
      }
      return this.statics.empty;
    },


    insuranceType() {
      if (this.report.policy_service) {
        return this.report.policy_service.length
          ? this.report.policy_service[0].branch_category_service.code
          : this.statics.empty;
      }
      return this.statics.empty;
    },

    storno() {
      if (this.report.policy_service) {
        return this.report.policy_service.length
          ? this.report.policy_service[0].policy_service_payment.agent
          : this.statics.empty;
      } else {
        return this.report.debit || this.statics.empty;
      }
    },

    isOpened() {
      if (this.report.policy_service) {
        for (let service of this.report.policy_service) {
          if (service.policy_service_payment) {
            for (let payment of service.policy_service_payment) {
              if (!payment.paid) {
                return false;
              }
            }
          } else {
            return false;
          }
        }
        return true;
      }
      return false;
    },

    balance() {
      return this.report.balance;
    },
  },
  methods: {
    deleteReport(id) {
      this.$store.commit("setDeleteModal", {
        display: true,
        message: '',
        action: () => this.deleteManualReport(id),
        id: id,
      });
    },


    async deleteManualReport(id) {
      try {
        await api({ requiresAuth: true }).delete(`/v1/transactions/${id}`);
        await this.$store.dispatch("getReports", this.teamId);
      } catch (err) {
        console.error(err);
      }
    },

    async openReport() {

      try {
        const response = await api({ requiresAuth: true }).get(
          `/v1/user-payouts/${this.report.payout_id}/pdf`,
          {
            responseType: "blob",
          }
        );

        // Check if response data exists and is valid
        if (!response.data || response.data.size === 0) {
          throw new Error("Empty PDF response received");
        }

        // Get content type from headers or set default
        const contentType = response.headers['content-type'] || 'application/pdf';

        // Create blob with the proper content type
        const blob = new Blob([response.data], { type: contentType });
        const fileURL = window.URL.createObjectURL(blob);

        // Create download link
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", "agent_payout.pdf");
        document.body.appendChild(fileLink);

        // Either open in new window or download based on content type
        if (contentType.includes("application/pdf") ||
          contentType.includes("image/jpeg") ||
          contentType.includes("image/png")) {
          const { width, height } = screen;
          window.open(
            fileURL,
            "_blank",
            `location=yes,width=${width},height=${height},scrollbars=yes,status=yes`
          );
        } else {
          fileLink.click();
        }

        // Clean up
        document.body.removeChild(fileLink);
        window.URL.revokeObjectURL(fileURL);
      } catch (err) {
        console.error("PDF download error:", err);

        // Handle specific error cases
        if (err.response) {
          // Server returned an error response
          const errorMessage = err.response.data instanceof Blob
            ? "Server error while generating PDF"
            : (err.response.data.message || "Error downloading PDF");

          this.$store.commit("setToast", {
            display: true,
            type: "error",
            message: errorMessage
          });
        } else {
          // Network error or client-side error
          this.$store.commit("setToast", {
            display: true,
            type: "error",
            message: "Error downloading PDF. Please try again."
          });
        }
      }
    }
  },
};
</script>

<style scoped lang="scss">
.report {
  margin-bottom: 15px;
  border-radius: var(--radius-1);
  background: var(--bg-1);
  box-shadow: 0px 0px 15px var(--shadow-4);
  position: relative;
  z-index: 1;
}
</style>
